<template>
    <div>
        <CModal
            :centered="true"
            color="white"
            :show.sync="isShown"
            :closeOnBackdrop="false"
            >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>Setting Jam Kerja</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="closeModal()" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div style="padding-right:20px;padding-left:20px;padding-bottom:20px;">
                    <CRow class="mb-4">
                        <CCol sm="6">
                            <label>Konsep Perhitungan Jam Kerja</label>
                            <model-select :options="dataIsFlexible"
                                class="form-control model-select"
                                v-model.trim="$v.isFlexible.$model"
                                :class="{ 'is-invalid select-invalid':$v.isFlexible.$error, 'is-valid select-valid': !$v.isFlexible.$invalid }"
                                placeholder="Pilih konsep perhitungan jam kerja">
                            </model-select>
                        </CCol>
                        <CCol sm="6" v-if="tipe != 'C'">
                            <label>Pengaturan Lembur</label>
                            <model-select :options="dataIsLembur"
                                class="form-control model-select"
                                v-model.trim="$v.isLembur.$model"
                                :class="{ 'is-invalid select-invalid':$v.isLembur.$error, 'is-valid select-valid': !$v.isLembur.$invalid }"
                                placeholder="Pilih pengaturan lembur">
                            </model-select>
                        </CCol>
                    </CRow>
                    <CRow class="mb-4">
                        <CCol sm="6">
                            <label>Pengaturan Istirahat</label>
                            <model-select :options="dataIsIstirahat"
                                class="form-control model-select"
                                v-model.trim="$v.isIstirahat.$model"
                                :class="{ 'is-invalid select-invalid':$v.isIstirahat.$error, 'is-valid select-valid': !$v.isIstirahat.$invalid }"
                                placeholder="Pilih pengaturan istirahat">
                            </model-select>
                        </CCol>
                        <CCol sm="6">
                            <label>Toleransi Terlambat (Menit)</label>
                            <input 
                                class="form-control mr-2" 
                                v-model.trim="$v.toleransi.$model"
                                :class="{ 'is-invalid':$v.toleransi.$error, 'is-valid': !$v.toleransi.$invalid }"
                                placeholder="Toleransi Menit" 
                                onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                                type="text"
                            />
                        </CCol>
                    </CRow>
                    <CRow class="mb-4">
                        <CCol sm="6">
                            <label>Pengaturan jam kerja dinas pada hari libur</label>
                            <model-select :options="dataIsDinasHoliday"
                                class="form-control model-select"
                                v-model.trim="$v.isDinasHoliday.$model"
                                :class="{ 'is-invalid select-invalid':$v.isDinasHoliday.$error, 'is-valid select-valid': !$v.isDinasHoliday.$invalid }"
                                placeholder="Pilih pengaturan jam kerja dinas">
                            </model-select>
                        </CCol>
                        <CCol sm="6">
                            <label>Pengaturan jam kerja pada izin, cuti, dan sakit</label>
                            <model-select :options="dataIsLeave"
                                class="form-control model-select"
                                v-model.trim="$v.isLeave.$model"
                                :class="{ 'is-invalid select-invalid':$v.isLeave.$error, 'is-valid select-valid': !$v.isLeave.$invalid }"
                                placeholder="Pilih pengaturan jam kerja pada izin, cuti dan sakit">
                            </model-select>
                        </CCol>
                    </CRow>
                    <CRow class="mb-4">
                        <CCol sm="12">
                            <CButton @click="closeModal()" type="button" class="btn btn-cancel mr-2">Batal</CButton>
                            <CButton @click="submitForm()" class="btn btn-edit-submit">
                                <span>Simpan</span>
                            </CButton>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
    </div>
</template>
<script>
import { ModelSelect } from 'vue-search-select'
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
export default {
    components: {
        ModelSelect
    },
    mixins: [validationMixin],
    validations: {
        toleransi: {
            required
        },
        isIstirahat: {
            text: {
                required
            },
            value: {
                required
            }
        },
        isFlexible: {
            text: {
                required
            },
            value: {
                required
            }
        },
        isLembur: {
            text: {
                required
            },
            value: {
                required
            }
        },
        isLeave: {
            text: {
                required
            },
            value: {
                required
            }
        },
        isDinasHoliday: {
            text: {
                required
            },
            value: {
                required
            }
        }
    },
    data() {
        return {
            isShown: false,
            loading: false,
            closeIcon: require('../assets/menu/icon_close.svg'),
            datas: [],
            toleransi: '',
            unix: '',
            isLembur: {
                text: '',
                value: ''
            },
            isFlexible: {
                text: '',
                value: ''
            },
            isIstirahat: {
                text: '',
                value: ''
            },
            isDinasHoliday: {
                text: '',
                value: ''
            },
            isLeave: {
                text: '',
                value: ''
            },
            dataIsLembur: [],
            dataIsIstirahat: [],
            dataIsFlexible: [],
            dataIsDinasHoliday: [],
            dataIsLeave: []
        }
    },
    methods: {
        closeModal() {
            this.isShown = false
            this.loading = false
            this.datas = []
        },
        openModal(value) {
            this.getDataDefault()
            let val = value
            
            let isFlexible = this.dataIsFlexible.find(({ value }) => value == val.isFlexible)
            this.isFlexible.value = isFlexible ? isFlexible.value : ''
            this.isFlexible.text = isFlexible ? isFlexible.text : ''

            let isIstirahat = this.dataIsIstirahat.find(({ value }) => value == val.isIstirahat)
            this.isIstirahat.value = isIstirahat ? isIstirahat.value : ''
            this.isIstirahat.text = isIstirahat ? isIstirahat.text : ''

            let isLembur = this.dataIsLembur.find(({ value }) => value == val.isLembur)
            this.isLembur.value = isLembur ? isLembur.value : ''
            this.isLembur.text = isLembur ? isLembur.text : ''

            let isLeave = this.dataIsLeave.find(({ value }) => value == val.isLeave)
            this.isLeave.value = isLeave ? isLeave.value : ''
            this.isLeave.text = isLeave ? isLeave.text : ''

            let isDinasHoliday = this.dataIsDinasHoliday.find(({ value }) => value == val.isDinasHoliday)
            this.isDinasHoliday.value = isDinasHoliday ? isDinasHoliday.value : ''
            this.isDinasHoliday.text = isDinasHoliday ? isDinasHoliday.text : ''

            this.toleransi = val.toleransi
            this.unix = val.unix

            this.isShown = true
        },
        getDownload() {
            this.$emit('download')
        },
        submitForm() {
            this.$v.$touch()
            if(this.$v.$invalid) {
            } else {
                let onPush = {
                    toleransi: this.toleransi,
                    isIstirahat: this.isIstirahat.value,
                    isLembur: this.isLembur.value,
                    isFlexible: this.isFlexible.value,
                    unix: this.unix,
                    isDinasHoliday: this.isDinasHoliday.value,
                    isLeave: this.isLeave.value
                }
                this.$emit('save', onPush)
                this.loading = true
            }
        },
        getDataDefault() {
            this.dataIsLembur = [
                {
                    text: 'Lembur TIDAK dianggap dan TIDAK dihitung sebagai jam kerja',
                    value: '0'
                },
                {
                    text: 'Lembur dianggap dan dihitung sebagai jam kerja',
                    value: '1'
                }
            ]
            this.dataIsIstirahat = [
                {
                    text: 'Waktu istirahat TIDAK dihitung sebagai jam kerja',
                    value: '0'
                },
                {
                    text: 'Waktu istirahat dihitung sebagai jam kerja',
                    value: '1'
                }
            ]
            this.dataIsFlexible = [
                {
                    text: 'Jam kerja dihitung sesuai jadwal',
                    value: '0'
                },
                {
                    text: 'Jam kerja dihitung sesuai absensi',
                    value: '1'
                }
            ]
            this.dataIsDinasHoliday = [
                {
                    text: 'Dinas pada hari libur TIDAK dihitung jam kerja',
                    value: '0'
                },
                {
                    text: 'Dinas pada hari libur dihitung jam kerja',
                    value: '1'
                }
            ]
            this.dataIsLeave = [
                {
                    text: 'Izin, Cuti, Sakit TIDAK dihitung jam kerja',
                    value: '0'
                },
                {
                    text: 'Izin, Cuti, Sakit dihitung jam kerja',
                    value: '1'
                }
            ]
        }
    },
    watch: {
    }
}
</script>

<style scoped>
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
::v-deep .modal-dialog {
    max-width: 50% !important;
}
label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input, .area-input .model-select {
    background-color: white;
    margin-bottom: 20px;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
    padding-top: 32px;
}
.select-invalid {
    border: 1px solid #e55353 !important;
}
.select-valid {
    border: 1px solid #2eb85c !important;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
::v-deep .ui.search.dropdown>.text {
    overflow: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
</style>